import { render, staticRenderFns } from "./OutputsCard.vue?vue&type=template&id=168779f8&"
import script from "./OutputsCard.vue?vue&type=script&lang=ts&"
export * from "./OutputsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports